import { SettlementLoadRecord } from '@api/Trinium/Endpoints/Settlements/types';
import { LoadCommissionLine } from './LoadsByServicePopper';

/** Largest total first. Grouped on the code rather than the name, since the code is what identifies a service. */
export function groupLoadsByService(loads: SettlementLoadRecord[]): LoadCommissionLine[] {
  const lines = new Map<string, LoadCommissionLine>();

  for (const load of loads) {
    const line = lines.get(load.serviceCode);
    if (line) {
      line.amount += load.commission;
      line.loads.push(load);
    } else {
      lines.set(load.serviceCode, {
        serviceCode: load.serviceCode,
        serviceDescription: load.serviceDescription,
        amount: load.commission,
        loads: [load]
      });
    }
  }

  return [...lines.values()].sort((a, b) => b.amount - a.amount);
}
